import axios from 'axios';
import Swal from 'sweetalert2';
import { getCandidateAssignments } from './getCandidateAssignments';
import { getPassportRequest } from './getPassportRequest';

export function submitPassportRequest(
  { userId, candidateId, feedback, fromFeedback },
  callback,
) {
  return async (dispatch) => {
    // Reversing an already-approved passport reduces the candidate's access (re-locks it, or
    // sends it back to pending), so confirm before sending. Other transitions go straight through.
    const reducesAccess = fromFeedback === 1 && feedback !== 1;
    if (reducesAccess) {
      const confirmed = await Swal.fire({
        title: 'Re-lock this passport?',
        text:
          'This removes the named passport access: it is hidden from search and sharing and shown anonymously again. Continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3f51b5',
        confirmButtonText: 'Yes, re-lock',
      });
      if (!confirmed.isConfirmed) return;
    }

    axios
      .put(`/candidate/${candidateId}/passport-request`, {
        feedback,
      })
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          let text;
          let title;
          let icon;
          switch (feedback) {
            case 0:
              // feedback 0 from the sponsor queue (fromFeedback set) is a reset-to-pending;
              // otherwise it is a candidate/searcher creating a request.
              if (fromFeedback === 1 || fromFeedback === 2) {
                title = 'Reset to Pending';
                text =
                  'This request is back to pending and awaiting your decision.';
                icon = 'success';
              } else {
                title = 'Passport Requested';
                text =
                  "The candidate's sponsor will review this request. Once approved, the named passport is unlocked. Until then, results can only be viewed anonymously.";
                icon = 'success';
              }
              break;

            case 1:
              title = 'Passport Request Approved';
              text =
                'You have approved this passport request. The named passport is now unlocked.';
              icon = 'success';
              break;

            case 2:
              title = 'Passport Request Rejected';
              text =
                'You have rejected this passport request. The passport stays anonymous, and you can approve it later without the candidate re-submitting.';
              icon = 'warning';
              break;

            default:
              break;
          }
          if (userId) {
            dispatch(getCandidateAssignments(userId));
            dispatch(getPassportRequest(userId));
          }
          Swal.fire({
            title,
            text,
            icon,
            confirmButtonColor: '#3f51b5',
          }).then(() => {
            if (callback) callback();
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
